import { ExternalFolderTable } from 'modules/components/layer25';



export type ExternalFolderDetailSectionProps = {
  folderId: string;
};

export const FC = ({
  folderId
}: ExternalFolderDetailSectionProps) => {
  return (
    <ExternalFolderTable.FC folderId={folderId} />
  );
};
